// NOTE: 'regenerator-runtime/runtime' is needed for rootSaga. It must be at top of file. See https://github.com/redux-saga/redux-saga/issues/280 for more information.
import 'regenerator-runtime/runtime'

import { all } from 'redux-saga/effects'

import autoIntegrateSaga from './autoIntegrateSaga'
import sessionSaga from './sessionSaga'
import shopOrderSaga from './shopOrderSaga'
import shopOrderStateSaga from './shopOrderStateSaga'
import mappingSaga from './mappingSaga'
import membershipSaga from './membershipSaga'
import orderIssueSaga from './orderIssueSaga'
import versionSaga from './versionSaga'

export default function* rootSaga() {
  yield all([
    /* NOTE: Add other sagas here */
    autoIntegrateSaga(),
    versionSaga(),
    orderIssueSaga(),
    membershipSaga(),
    sessionSaga(),
    shopOrderSaga(),
    shopOrderStateSaga(),
    mappingSaga()
  ])
}
